<template>
  <div>
    <div class="pa-4 d-flex justify-center" v-if="data.objects.length == 0">
      <strong>{{ $t('Nenhum registro encontrado') }}</strong>
    </div>

    <strong class="ma-2">
      {{ total ? total.toInstLocale() : '0,00' }}
    </strong>

    <v-simple-table class="main-table" dense v-if="data.objects.length > 0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left">O.S.</th>
            <th class="text-left">{{ $t('Setor') }}</th>
            <th class="text-left">{{ $t('Descrição') }}</th>
            <th class="text-left">{{ $t('Valor') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data.objects" :key="item.identification">
            <td></td>
            <td>{{ item.osNumber }}</td>
            <td>{{ item.sector }}</td>
            <td>{{ item.costDescription }}</td>
            <td>{{ item.costValueString }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="pagination">
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../services/ApiService'

export default {
  name: 'EquipStoppedComponent',

  props: {
    unidadeIds: Array,
    departmentIds: Array,
    institutionIds: Array,
  },

  watch: {
    unidadeIds() {
      this.filter.unidadeIds = this.unidadeIds
    },
    departmentIds() {
      this.filter.departmentIds = this.departmentIds
    },
    institutionIds() {
      this.filter.institutionIds = this.institutionIds
    },
    page() {
      this.filter.page = this.page
      this.list()
    },
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      total: 0,
      apiService: new ApiService(),
      filter: {
        page: 1,
        pageSize: 10,
        unidadeIds: [],
        departmentIds: [],
        institutionIds: [],
        institutionId: 1,
      },
      data: {
        objects: [],
        dataByMonth: [],
      },
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/yyyy hh:mm')
      } else return 'Sem registro'
    },

    list() {
      this.apiService
        .post('dash/avoided-costs', this.filter)
        .then((response) => {
          this.total = response.content.total
          this.data = response.content.viewModel
          this.totalPages = response.content.viewModel.pager.totalPages
        })
    },
  },
}
</script>

<style scoped></style>
